import React from "react";
import { Col, FormGroup, Row } from "reactstrap";

import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import FormDropdownField from "src/components/Form/FormDropdownField/FormDropdownField";
import SimpleDatePickerField from "src/components/Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import { IOption } from "src/store/models/option.model";
import * as S from "../../../constants/StringConstants";
import "./../BrokerCommentsWidget/BrokerCommentsWidget.scss";

interface CommentFormProps {
  priorityList: IOption[];
  newComment?: string;
  setNewComment?: React.Dispatch<React.SetStateAction<string>>;
}

export const CommentForm: React.FC<CommentFormProps> = ({ priorityList, newComment, setNewComment }) => {
  return (
    <>
      <Row>
        <Col>
          <Row>
            <Col sm="12">
              <FormGroup>
                <SimpleDatePickerField label={S.APP_COMMENTS_FIELD_NOTIFICATION_DATE_LABEL} name="dueDate" isFormMode />
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col sm="12">
              <FormGroup>
                <SimpleDatePickerField
                  label={S.APP_COMMENTS_FIELD_FOLLOW_UP_DATE_LABEL}
                  name="followUpDate"
                  isFormMode
                />
              </FormGroup>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col sm="12">
              <FormGroup>
                <FormDropdownField
                  name="commentPriorityID"
                  label={S.APP_COMMENTS_FIELD_PRIORITY_LABEL}
                  options={priorityList}
                />
              </FormGroup>
            </Col>
          </Row>
        </Col>
        <Col>
          <Row>
            <Col sm="12">
              <FormGroup>
                <CheckboxField
                  name="confidentialFlag"
                  label={S.APP_COMMENTS_FIELD_CONFIDENTIAL_LABEL}
                  labelPosition="above"
                />
              </FormGroup>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <TextField
              name="description"
              label={S.APP_COMMENTS_FIELD_DESCRIPTION_LABEL}
              multiline
              value={newComment}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setNewComment && setNewComment(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};
